import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/_components/HomePage.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/game/templates/index.tsx")